import * as Sentry from '@sentry/react';

export function initializeSentry(o11yConfig) {
  Sentry.init({
    enabled: o11yConfig.enableSentry,
    dsn: o11yConfig.sentryDsn,
    environment: o11yConfig.environment,
    sampleRate: 1.0,
    tracesSampleRate: 1.0,
    initialScope: {
      tags: {
        deploymentName: o11yConfig.deploymentName,
        awsAccount: o11yConfig.awsAccount,
        instanceType: o11yConfig.instanceType,
        serviceName: 'retro-score-frontend',
      },
    },
  });
  Sentry.getCurrentScope().setLevel('error');
}
